import { useCallback } from "react";

type HapticType = "light" | "medium" | "heavy";

/**
 * Custom hook to provide haptic feedback on supported Android devices.
 * iOS Safari doesn't support the Vibration API for security reasons.
 */
export const useHapticFeedback = () => {
  const vibrate = useCallback((type: HapticType = "light") => {
    // Check if Vibration API is supported (mainly Android)
    if (!navigator.vibrate) return;

    const patterns: Record<HapticType, number | number[]> = {
      light: 10,
      medium: 25,
      heavy: 50,
    };

    try {
      navigator.vibrate(patterns[type]);
    } catch (error) {
      // Silently fail if vibration isn't available
      console.debug("Haptic feedback not available");
    }
  }, []);

  const lightTap = useCallback(() => vibrate("light"), [vibrate]);
  const mediumTap = useCallback(() => vibrate("medium"), [vibrate]);
  const heavyTap = useCallback(() => vibrate("heavy"), [vibrate]);

  return { vibrate, lightTap, mediumTap, heavyTap };
};

export default useHapticFeedback;
